import { KonvaEventObject } from 'konva/lib/Node';
import { useCallback, useMemo, useRef } from 'react';

export function useCursorHandlers() {
  const currentCursorRef = useRef<string>('default');

  const setCursor = useCallback(
    (cursor: string, e: KonvaEventObject<MouseEvent>) => {
      if (currentCursorRef.current === cursor) return;
      const stage = e.target.getStage();
      if (stage) {
        stage.container().style.cursor = cursor;
        currentCursorRef.current = cursor;
      }
    },
    []
  );

  const createCursorEnter = useCallback(
    (cursor: string) => (e: KonvaEventObject<MouseEvent>) => {
      setCursor(cursor, e);
    },
    [setCursor]
  );

  const handleCursorLeave = useCallback(
    (e: KonvaEventObject<MouseEvent>) => {
      setCursor('default', e);
    },
    [setCursor]
  );

  const crosshairCursorEnter = useMemo(
    () => createCursorEnter('crosshair'),
    [createCursorEnter]
  );

  const resizeCursorEnter = useMemo(
    () => createCursorEnter('nwse-resize'),
    [createCursorEnter]
  );

  return { crosshairCursorEnter, resizeCursorEnter, handleCursorLeave };
}
